;(function () {
	const header = () => {
		const header = document.querySelector('.shopify-section-header')
		const menu = header?.querySelector('.list-menu--inline')
		const menuLinks = menu ? menu.querySelectorAll(':scope > .list-menu-item') : []
		const search = header?.querySelector('.header__search')
		window.__moztechHeaderEvents?.abort()
		const eventController = new AbortController()
		const { signal } = eventController
		window.__moztechHeaderEvents = eventController

		let hideMenuTimeout
		const megaMenuCloseDelay = 260

		if (!header) return

		header.addEventListener('keydown', (e) => {
			if (e.code === 'Escape' && search?.isOpen) {
				search.close()
			}
		}, { signal })

		const annBar = document.querySelector('.section-announcement')
		const syncAnnBarHeight = () => {
			const isVisible = annBar
				&& annBar.getClientRects().length > 0
				&& window.getComputedStyle(annBar).display !== 'none'
			const height = isVisible
				? Math.ceil(annBar.getBoundingClientRect().height)
				: 0

			document.documentElement.style.setProperty('--ann-height', `${height}px`)
		}
		const annBarObserver = typeof ResizeObserver === 'function'
			? new ResizeObserver(syncAnnBarHeight)
			: null
		window.__moztechAnnouncementObserver?.disconnect()
		window.__moztechAnnouncementObserver = annBarObserver
		if (annBar && annBarObserver) annBarObserver.observe(annBar)
		window.addEventListener('resize', syncAnnBarHeight, { signal })
		syncAnnBarHeight()

		const cancelMegaMenuClose = () => {
			window.clearTimeout(hideMenuTimeout)
		}
		const getMegaMenu = (link) => link.querySelector(':scope > .mega-menu')
		const closeMegaMenu = (link) => {
			const megaMenu = getMegaMenu(link)
			if (!megaMenu) return

			link.classList.remove('list-menu--megamenu-visible')
			megaMenu.style.opacity = 0
			megaMenu.style.display = 'none'
			megaMenu.style.right = 'auto'
		}
		const closeMegaMenus = (except) => {
			menuLinks.forEach((link) => {
				if (link !== except && link.classList.contains('list-menu--megamenu')) {
					closeMegaMenu(link)
				}
			})
		}
		const positionMegaMenu = (megaMenu) => {
			const headerMain = header.querySelector('.header')
			if (!headerMain) return

			megaMenu.style.right = 'auto'
			const megaMenuTabs = megaMenu.querySelector('.mega-menu__tabs')

			if (megaMenuTabs?.scrollWidth > megaMenu.offsetWidth) {
				megaMenu.style.maxWidth = `${megaMenuTabs.scrollWidth}px`
				megaMenu.style.width = `${megaMenuTabs.scrollWidth}px`
			}

			if (megaMenu.getBoundingClientRect().right > headerMain.getBoundingClientRect().right) {
				megaMenu.style.right = '2rem'
			}
		}
		const openMegaMenu = (link) => {
			const megaMenu = getMegaMenu(link)
			if (!megaMenu) return

			cancelMegaMenuClose()
			closeMegaMenus(link)
			link.classList.add('list-menu--megamenu-visible')
			megaMenu.style.opacity = 0
			megaMenu.style.display = 'grid'
			positionMegaMenu(megaMenu)

			window.requestAnimationFrame(() => {
				if (link.classList.contains('list-menu--megamenu-visible')) {
					megaMenu.style.opacity = 1
				}
			})
		}
		const scheduleMegaMenuClose = (link) => {
			cancelMegaMenuClose()
			hideMenuTimeout = window.setTimeout(() => {
				if (link.matches(':hover') || link.matches(':focus-within')) return
				closeMegaMenu(link)
			}, megaMenuCloseDelay)
		}

		menuLinks.forEach((link) => {
			link.addEventListener('mouseenter', () => {
				if (link.classList.contains('list-menu--megamenu')) {
					openMegaMenu(link)
				} else {
					cancelMegaMenuClose()
					closeMegaMenus()
				}
			}, { signal })
			link.addEventListener('mouseleave', () => {
				if (link.classList.contains('list-menu--megamenu')) {
					scheduleMegaMenuClose(link)
				}
			}, { signal })
			link.addEventListener('focusin', () => {
				if (link.classList.contains('list-menu--megamenu')) {
					openMegaMenu(link)
				} else {
					cancelMegaMenuClose()
					closeMegaMenus()
				}
			}, { signal })

			const megaMenu = getMegaMenu(link)
			if (megaMenu) {
				megaMenu.addEventListener('mouseenter', cancelMegaMenuClose, { signal })
				megaMenu.addEventListener('mouseleave', () => scheduleMegaMenuClose(link), { signal })
			}
		})
		if (menu) {
			menu.addEventListener('mouseleave', () => {
				const activeMegaMenu = menu.querySelector('.list-menu--megamenu-visible')
				if (activeMegaMenu) scheduleMegaMenuClose(activeMegaMenu)
			}, { signal })
			menu.addEventListener('focusout', () => {
				window.setTimeout(() => {
					if (menu.contains(document.activeElement)) return
					cancelMegaMenuClose()
					closeMegaMenus()
				}, 0)
			}, { signal })
		}

		const megaMenuTabs = () => {
			$('.mega-menu__tab-wrapper')
				.children()
				.find('.mega-menu__tab-wrapper')
				.first()
				.addClass('mega-menu__tab-wrapper--active')
			$('.mega-menu__tab-wrapper').off('.mozHeader').on('mouseenter.mozHeader focus.mozHeader focusin.mozHeader', function () {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
		}
		megaMenuTabs()

		const main = document.querySelector('main')
		const breadcrumbs = document.querySelector('.breadcrumbs-wrapper')
		if (
			main?.querySelectorAll('.shopify-section')[0] &&
			main
				.querySelectorAll('.shopify-section')[0]
				.classList.contains('section--has-overlay')
		) {
		}

		const menuCloseBtn = document.querySelector('.header__modal-close-button')
		const mobileMenuDrawer = document.querySelector('header-drawer')
		if (menuCloseBtn && mobileMenuDrawer?.closeMenuDrawer) {
			menuCloseBtn.addEventListener('click', (e) => {
				mobileMenuDrawer.closeMenuDrawer(e)
			}, { signal })
		}
	}

	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)

	header()
})()
